import { motion } from "framer-motion";
import { useLang } from "@/lib/i18n";

const EASE = [0.16, 1, 0.3, 1];

export const BrandHouses = ({ brands, onSelect }) => {
  const { t, pick } = useLang();
  return (
  <section id="huizen" className="px-6 sm:px-12 lg:px-20 py-24 lg:py-32">
    <div className="flex flex-wrap items-end justify-between gap-6 mb-14">
      <div>
        <motion.p
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.8, ease: EASE }}
          className="font-mono text-[10px] tracking-[0.35em] uppercase text-gold/85 mb-6"
        >
          {t("home.housesEyebrow")}
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.9, delay: 0.08, ease: EASE }}
          className="font-serif font-light uppercase text-cream text-3xl sm:text-4xl lg:text-5xl"
        >
          {t("home.housesTitle1")} <span className="italic normal-case text-gold">{t("home.housesTitle2")}</span>
        </motion.h2>
      </div>
      <p className="font-mono text-[10px] tracking-[0.25em] uppercase text-smoke max-w-xs text-right hidden md:block">
        {t("home.housesHint")}
      </p>
    </div>

    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6">
      {brands.map((b, i) => (
        <motion.button
          key={b.slug}
          data-testid={`brand-house-${b.slug}`}
          onClick={() => onSelect(b.slug)}
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.7, delay: (i % 4) * 0.07, ease: EASE }}
          whileHover={{ y: -6 }}
          className={`group text-left border p-6 sm:p-8 min-h-[180px] flex flex-col justify-between transition-colors duration-500 ${
            b.slug === "axe"
              ? "border-gold/40 bg-gradient-to-b from-gold/[0.08] to-transparent"
              : "border-gold/10 bg-ink hover:border-gold/30"
          }`}
        >
          <div>
            <h3
              className={`font-serif text-2xl sm:text-3xl tracking-wide ${
                b.slug === "axe" ? "text-gold" : "text-cream group-hover:text-gold"
              } transition-colors duration-500`}
            >
              {pick(b, "name")}
            </h3>
            <p className="mt-3 text-xs sm:text-sm text-mist leading-relaxed">{pick(b, "tagline")}</p>
          </div>
          <p className="mt-6 font-mono text-[10px] tracking-[0.25em] uppercase text-smoke group-hover:text-gold/70 transition-colors duration-500">
            {b.product_count > 0 ? `${b.product_count} ${t("home.compositions")}` : t("home.soon")}
          </p>
        </motion.button>
      ))}
    </div>
  </section>
  );
};

export default BrandHouses;
